import {
  CREATE_ORDER_REQUEST,
  CREATE_ORDER_SUCCESS,
  CREATE_ORDER_FAIL,
  MY_ORDERS_REQUEST,
  MY_ORDERS_SUCCESS,
  MY_ORDERS_FAIL,
  ALL_ORDERS_REQUEST,
  ALL_ORDERS_SUCCESS,
  ALL_ORDERS_FAIL,
  UPDATE_ORDER_REQUEST,
  UPDATE_ORDER_SUCCESS,
  UPDATE_ORDER_FAIL,
  DELETE_ORDER_REQUEST,
  DELETE_ORDER_SUCCESS,
  DELETE_ORDER_FAIL,
  ORDER_DETAILS_REQUEST,
  ORDER_DETAILS_SUCCESS,
  ORDER_DETAILS_FAIL,
  CREDIT_COUNTS_REQUEST,
  CREDIT_COUNTS_SUCCESS,
  CREDIT_COUNTS_FAIL,
  CLEAR_ERRORS,
} from "../constants/orderConstants";
import axios from "axios";
import cookieCutter from "cookie-cutter";
import { getCorporateToken } from "../utils/authTokens";
// Create Order
export const createOrder = (order) => async (dispatch) => {
  try {
    dispatch({ type: CREATE_ORDER_REQUEST });
    const token = getCorporateToken();
    const config = { headers: { "Content-Type": "application/json" }, token };
    const { data } = await axios.post(`/api/v1/corporateOrder/new`, {
      config,
      withCredentials: true,
      order,
    });
    
    dispatch({ type: CREATE_ORDER_SUCCESS, payload: data.success });
  } catch (error) {
    dispatch({
      type: CREATE_ORDER_FAIL,
      payload: error.response.data.message,
    });
  }
};

export const myOrders = () => async (dispatch) => {
  try {
    const token = getCorporateToken();
    dispatch({ type: MY_ORDERS_REQUEST });
    const response = await axios.get(`/api/v1/corporateOrders/me`, {
      method: "GET",
      headers: { "Content-Type": "application/json", token, methods: "GET" },
      credentials: "include",
    });
    if (response) {
      dispatch({
        type: MY_ORDERS_SUCCESS,
        payload: response.data.orders,
      });
    } else {
      dispatch({ type: LOAD_USER_FAIL, payload: "Failed to load user" });
    }
  } catch (error) {
    dispatch({
      type: MY_ORDERS_FAIL,
      payload: error?.response?.data?.message,
    });
  }
};

//credit count

export const creditCounts = () => async (dispatch) => {
  try {
    const token = getCorporateToken();
    dispatch({ type: CREDIT_COUNTS_REQUEST });
    const response = await axios.get(`/api/v1/getCredits`, {
      method: "GET",
      headers: { "Content-Type": "application/json", token, methods: "GET" },
      credentials: "include",
    });
    if (response) {
      dispatch({
        type: CREDIT_COUNTS_SUCCESS,
        payload: response.data,
      });
    } else {
      dispatch({ type: LOAD_USER_FAIL, payload: "Failed to load user" });
    }
  } catch (error) {

    dispatch({
      type: CREDIT_COUNTS_FAIL,
      payload: error.response.data.message,
    });
  }
};

// Get All Orders (admin)
export const getAllOrders = () => async (dispatch) => {
  try {
    dispatch({ type: ALL_ORDERS_REQUEST });

    const { data } = await axios.get("/api/v1/admin/orders");

    dispatch({ type: ALL_ORDERS_SUCCESS, payload: data.orders });
  } catch (error) {
    dispatch({
      type: ALL_ORDERS_FAIL,
      payload: error.response.data.message,
    });
  }
};

// Update Order
export const updateOrder = (id, order) => async (dispatch) => {
  try {
    dispatch({ type: UPDATE_ORDER_REQUEST });

    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    const { data } = await axios.put(
      `/api/v1/admin/order/${id}`,
      order,
      config
    );

    dispatch({ type: UPDATE_ORDER_SUCCESS, payload: data.success });
  } catch (error) {
    dispatch({
      type: UPDATE_ORDER_FAIL,
      payload: error.response.data.message,
    });
  }
};

// Delete Order
export const deleteOrder = (id) => async (dispatch) => {
  try {
    dispatch({ type: DELETE_ORDER_REQUEST });

    const { data } = await axios.delete(`/api/v1/admin/order/${id}`);

    dispatch({ type: DELETE_ORDER_SUCCESS, payload: data.success });
  } catch (error) {
    dispatch({
      type: DELETE_ORDER_FAIL,
      payload: error.response.data.message,
    });
  }
};

// Get Order Details
export const getOrderDetails = (id) => async (dispatch) => {
  try {
    dispatch({ type: ORDER_DETAILS_REQUEST });

    const { data } = await axios.get(`/api/v1/order/${id}`);

    dispatch({ type: ORDER_DETAILS_SUCCESS, payload: data.order });
  } catch (error) {
    dispatch({
      type: ORDER_DETAILS_FAIL,
      payload: error.response.data.message,
    });
  }
};

// Clearing Errors
export const clearErrors = () => async (dispatch) => {
  dispatch({ type: CLEAR_ERRORS });
};
